<template>
  <el-form
    ref="chamberForm"
    :model="form"
    :rules="rules"
    label-width="150px"
    label-position="right"
    style="margin-bottom: 0; background-color: #fff; padding: 20px"
  >
    <!-- 商会组织编号 -->
    <el-form-item label="商会组织编号：" prop="code" class="required-field">
      <el-input
        v-model="form.code"
        placeholder="请输入商会组织编号"
        clearable
      />
    </el-form-item>

    <!-- 商会组织名称 -->
    <el-form-item label="商会组织名称：" prop="name" class="required-field">
      <el-input
        v-model="form.name"
        placeholder="请输入商会组织名称"
        clearable
      />
    </el-form-item>

    <!-- 商会组织类型 -->
    <el-form-item label="商会组织类型：" prop="type">
      <el-checkbox-group v-model="form.type">
        <el-checkbox label="传统商会"></el-checkbox>
        <el-checkbox label="行业商会"></el-checkbox>
        <el-checkbox label="综合商会"></el-checkbox>
        <el-checkbox label="其他商会"></el-checkbox>
      </el-checkbox-group>
    </el-form-item>

    <!-- 商会组织级别 -->
    <el-form-item label="商会组织级别：" prop="level">
      <el-radio-group v-model="form.level">
        <el-radio label="国家级"></el-radio>
        <el-radio label="省级"></el-radio>
        <el-radio label="市区级" checked></el-radio>
        <el-radio label="行业级"></el-radio>
        <el-radio label="其他级别"></el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 成立登记日期 -->
    <el-form-item label="成立登记日期：" prop="establishDate">
      <el-date-picker
        v-model="form.establishDate"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
      />
    </el-form-item>

    <!-- 商会地址 -->
    <el-form-item label="商会地址：" prop="address">
      <div class="address">
        <EarthAreaSelect
          :country="form.country"
          :province="form.province"
          :city="form.city"
          :region="form.region"
          @searchCountry="searchCountry"
          @searchProvince="searchProvince"
          @searchCity="searchCity"
        />
      </div>
    </el-form-item>
    <el-form-item label="具体地址：" prop="address">
      <div class="detailAddress">
        <el-input
          v-model="form.detailAddress"
          placeholder="请输入具体地址"
          style="margin-top: 10px"
        />
        <div class="tip-text">{{ form.detailAddress.length || 0 }}/30</div>
      </div>
    </el-form-item>

    <!-- 运营状态 -->
    <el-form-item label="运营状态：" prop="status">
      <el-input v-model="form.status" placeholder="请输入运营状态" />
    </el-form-item>

    <!-- 商会组织介绍 -->
    <el-form-item label="商会组织介绍：" prop="description">
      <el-input
        v-model="form.description"
        type="textarea"
        :rows="4"
        placeholder="请输入商会组织介绍"
        show-word-limit
        maxlength="650"
      />
    </el-form-item>

    <!-- 商会组织logo -->
    <el-form-item label="商会组织logo：" prop="logo">
      <el-upload
        action="https://jsonplaceholder.typicode.com/posts/"
        list-type="picture-card"
        :on-preview="handleLogoPreview"
        :on-remove="handleLogoRemove"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
    </el-form-item>

    <!-- 网站/微网站 -->
    <el-form-item label="网站/微网站：" prop="website">
      <el-input
        v-model="form.website"
        placeholder="请输入商会组织网站/微网站"
      />
    </el-form-item>

    <!-- 公众号 -->
    <el-form-item label="商会组织公众号：" prop="officialAccount">
      <el-input
        v-model="form.officialAccount"
        placeholder="请输入商会组织公众号"
      />
    </el-form-item>

    <!-- 联系方式 -->
    <el-form-item label="商会组织联系方式：" prop="contact">
      <el-input v-model="form.contact" placeholder="请输入商会组织联系方式" />
    </el-form-item>

    <!-- 业务主管机构 -->
    <el-form-item label="业务主管机构：" prop="governingBody">
      <el-input v-model="form.governingBody" placeholder="请输入业务主管机构" />
    </el-form-item>

    <!-- 业务类型 -->
    <el-form-item label="业务类型：" prop="businessType">
      <el-input v-model="form.businessType" placeholder="请输入业务类型" />
    </el-form-item>

    <!-- 宗旨 -->
    <el-form-item label="宗旨：" prop="purpose">
      <el-input
        v-model="form.purpose"
        type="textarea"
        :rows="2"
        placeholder="请输入宗旨"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import EarthAreaSelect from "@/components/EarthAreaSelect";
export default {
  components: {
    EarthAreaSelect,
  },
  data() {
    return {
      form: {
        code: "",
        name: "",
        type: ["综合商会"],
        level: "市区级",
        establishDate: "2018-12-12",
        address: [],
        detailAddress: "",
        status: "",
        description: "",
        logo: "",
        website: "",
        officialAccount: "",
        contact: "",
        governingBody: "",
        businessType: "",
        purpose: "",
        country: "中国", // 国家
        province: "", // 省份
        city: "", // 城市
        region: "",
      },
      rules: {
        code: [
          { required: true, message: "请输入商会组织编号", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入商会组织名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    submit() {
      this.$refs.chamberForm.validate((valid) => {
        if (valid) {
          console.log("表单数据:", this.form);
          this.$message.success("提交成功！");
        } else {
          this.$message.error("请检查表单填写是否正确");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.chamberForm.resetFields();
    },
    handleLogoPreview(file) {
      console.log("预览:", file);
    },
    handleLogoRemove(file, fileList) {
      console.log("移除:", file, fileList);
    },
    searchCountry() {},
    searchProvince() {},
    searchCity() {},
  },
};
</script>

<style scoped>
.chamber-form {
  max-width: 900px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.required-field .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.detailAddress{
  position: relative;
}

.tip-text {
  font-size: 12px;
  color: #909399;
  position: absolute;
  top: 16px;
  left: 436px;
}
::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-textarea {
  width: 470px;
}
.address ::v-deep .el-input__inner {
  width: 100%;
}
</style>